import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SmsProviderList from "./SmsProviderList";
import Footer from "./Footer";
const SmsProvider = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <SmsProviderList />
      <Footer />
    </>
  );
};

export default SmsProvider;
